import React, { memo, useMemo } from 'react'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setTextureQuality } from 'Pods/ThreeDStudio/Store/actions/textureSettings'
import { TEXTURE_QUALITY } from 'Pods/ThreeDStudio/Store/constants'

// Fixed candidate order, filtered per render to whatever the active provider's
// retexture schema actually supports (Tripo3D: 2k/4k, Meshy: 2k/4k/8k). A schema
// without texture_quality (Hunyuan) has no resolution control at all.
const CANDIDATES = [TEXTURE_QUALITY.TWO_K, TEXTURE_QUALITY.FOUR_K, TEXTURE_QUALITY.EIGHT_K]

const handleClickFor = {
  [TEXTURE_QUALITY.TWO_K]: () => setTextureQuality(TEXTURE_QUALITY.TWO_K),
  [TEXTURE_QUALITY.FOUR_K]: () => setTextureQuality(TEXTURE_QUALITY.FOUR_K),
  [TEXTURE_QUALITY.EIGHT_K]: () => setTextureQuality(TEXTURE_QUALITY.EIGHT_K),
}

function TextureQualitySelector() {
  const t = useTranslation()
  const { isFullyDisabled, disabledValues } = useDisabledSelector('texture_quality', 'enhancedModelSchema')
  const allowedValues = useThreeDStudioStore(
    state => state.schema?.enhancedModelSchema?.input_schema?.properties?.texture_quality?.enum,
  )

  const buttons = useMemo(() => (
    CANDIDATES
      .filter(id => allowedValues?.includes(id))
      .map(id => ({
        id,
        label: t(`viewerSidebar.enhance.texture.resolution.${id}`),
        onClick: handleClickFor[id],
        disabled: isFullyDisabled || disabledValues.includes(id),
      }))
  ), [t, allowedValues, isFullyDisabled, disabledValues])

  if (buttons.length < 2) {
    return null
  }

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="textureQuality"
      sliceName="textureSettings"
      label={t('viewerSidebar.enhance.texture.resolution.label')}
    />
  )
}

export default memo(TextureQualitySelector)
